import { Flex as AntdFlex } from 'antd';
import { FC, ReactNode } from 'react';
import { FlexProps } from 'antd/lib';

type Props = {
  children?: ReactNode;
  vertical?: boolean;
  align?: 'center' | 'start' | 'end' | 'baseline' | 'stretch';
  gap?: number;
  justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between';
  style?: object;
  direction?: 'row' | 'column' | 'column-reverse';
  wrap?: boolean;
  onClick?: any;
};

export const Flex: FC<Props> = (props: any) => {
  return <AntdFlex {...props}>{props.children}</AntdFlex>;
};

export default Flex;
